import * as CONST from '../../constants';

const INITIAL_STATE = { loading: true, data: [], error: null };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONST.MEALZ_DRIVER_PICK_UP_REPORT_REQUEST:
      return { ...INITIAL_STATE, loading: true };
    case CONST.MEALZ_DRIVER_PICK_UP_REPORT_SUCCESS:
      return { ...INITIAL_STATE, loading: false, data: action.data.data };
    case CONST.MEALZ_DRIVER_PICK_UP_REPORT_ERROR:
      return { ...INITIAL_STATE, loading: false, error: action.error };
    default:
      return state;
  }
};
